import React from 'react';
import { ActionableMessage, ActionableMessageProps } from 'app/components/widgets/chat/message-types';
import { useSynapse } from 'app/lib/synaptik';

interface PhoneCallBackMessageProps extends ActionableMessageProps {
  scrollToBottom: () => void;
}

export const PhoneCallBackMessage: React.FC<PhoneCallBackMessageProps> = ({
  message,
  messageRef,
  scrollToBottom,
  onActionClick,
  ...props
}) => {
  const [sendingMessage, hasLaterMessage] = useSynapse(({ chat }) => [chat.state.sending, chat.hasLaterMessage]);

  return (
    <ActionableMessage
      message={message}
      onActionClick={onActionClick}
      disabled={sendingMessage || hasLaterMessage({ message })}
      {...props}
    />
  );
};
